var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXmark = function SvgXmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 429 429"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M365.6 109.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L215 169.7 109.6 64.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L169.7 215 64.4 320.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L215 260.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L260.3 215z"
  })));
};
export default SvgXmark;